import { render, staticRenderFns } from "./Dragable.vue?vue&type=template&id=7368aade&scoped=true&"
import script from "./Dragable.vue?vue&type=script&lang=js&"
export * from "./Dragable.vue?vue&type=script&lang=js&"
import style0 from "./Dragable.vue?vue&type=style&index=0&id=7368aade&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7368aade",
  null
  
)

export default component.exports